import React from "react";

import { history } from "../../../history/history";
import { removeData } from "../../../util/util";

const logoutSalesUser = () => {
  removeData("salesUserInfo");
  removeData("userInfo")
  history.push("/tp/login");
};

//Logout button
const SalesUserLogout = (props) => {
  return (
    <div className="dash_header_right" >
      <a onClick={logoutSalesUser}>
        LOGOUT{" "}
        <img src="../../assets/images/logout.svg" className="dash_logout" />      </a>
        <div className="supportlink" style={{ marginTop:"7px",fontSize:12 }}><a style={{color:'white'}} target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfEbCiG9bLYZvO1tK9Kczswnv7905Z9g1DHx09YjKIEkTYQOg/viewform">Support Portal</a> </div>         
    </div>
    
  );
};

export default SalesUserLogout;



// WEBPACK FOOTER //
// ./web/components/salesUser/common/Logout.jsx